import React,{ Suspense, useEffect } from 'react'
import {  BrowserRouter } from 'react-router-dom'
import 'react-calendar/dist/Calendar.css';
import { RecoilRoot } from 'recoil';
import { AppRouter } from './routes/AppRouter';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@emotion/react';
import theme from './theme';
import StylesGlobal from './layout/StylesGlobal';
import GlobalShowSnackbar from './shared/components/alerts/GlobalShowSnackbar';
import authGuestAction from './Patient/actions/authGuestAction';
import VerifyPatientRegister from './shared/components/patient/VerifyPatientRegister';
import ModalEditFilters from './SearchHours/components/modalEditFilters/ModalEditFilters';
import ModalShowPhoto from './Professional/ModalShowPhoto';
import Preloader from './shared/components/loadings/Preloader';
import ReagendarHora from './ResultSearch/components/ReagendarHora';
import AgendarHoraEsp from  './ResultSearch/components/AgendarHoraEsp';
import queryString from 'query-string';
import MedicoAgendaDirecta from './ResultSearch/components/MedicoAgendaDirecta';
import TotemAgenda from './ResultSearch/components/TotemAgenda';
import AgendarHoraExterno from './ResultSearch/components/AgendarHoraExterno';
//import ReactGA from 'react-ga';
import ReactGA from "react-ga4";
import TagManager from 'react-gtm-module'
import ManageStorage from 'src/shared/global/manageStorage';
 
const tagManagerArgs = {
    gtmId: process.env.REACT_APP_GOOGLE_TAG_MANAGER,
}
 
function App() {
  const query = queryString.parse(window.location.search)

  const initReactGA = () => {
    ReactGA.initialize(process.env.REACT_APP_ANALYTICS_4);
    //ReactGA.pageview(window.location.pathname + window.location.search);
    ReactGA.send({ hitType: "pageview", page: window.location.pathname + window.location.search });
  };

  const initReactGTM = () => {
    TagManager.initialize(tagManagerArgs);
  }
  
  const getNavigator = () => {
    if ("geolocation" in navigator) {
      console.log("Available geolocation");
      navigator.geolocation.getCurrentPosition(function(position) {
        console.log("Latitude is :", position.coords.latitude);
        console.log("Longitude is :", position.coords.longitude);
        ManageStorage.setItemStorage("lat", position.coords.latitude);
        ManageStorage.setItemStorage("lon", position.coords.longitude);
      });
    } else {
      console.log("Not Available");
    }
  }

  useEffect(() => {
    authGuestAction();
    initReactGA();
    //initReactGTM();
    ////getNavigator();    
  }, [])

  return (
    <RecoilRoot>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <StylesGlobal theme={theme} />
        {query && query.ra_id !== undefined && query.ra_id !== "" && <ReagendarHora />}
        {query && query.qrp !== undefined && query.qrp !== "" && <MedicoAgendaDirecta />}
        {query && query.totem !== undefined && query.totem !== "" && <TotemAgenda />}
        {query && query.ext !== undefined && query.ext !== "" && <AgendarHoraExterno />}
        {query && query.qec !== undefined && query.qec !== "" && <AgendarHoraEsp />}
        <Preloader />
        <VerifyPatientRegister />
        <GlobalShowSnackbar />

        <ModalEditFilters />
        <ModalShowPhoto />
        <Suspense fallback={null}>
          <BrowserRouter>
            <AppRouter />          
          </BrowserRouter>

        </Suspense>
      </ThemeProvider>
    </RecoilRoot>
  );
}

export default App;